function InitalizeHobbiesAndInterests() {
    $('#hobbies-interests-container .Expando').expando({ duration: '200', headerSelector: 'h1' });

    $('#hobbies-interests-container .Expando label').click(function() {
        $(this).closest('.Expando').find('.hobbies-parent').click();
    });

    $('.hobbies-parent-selection').click(function (e) {
        var $0 = $(this);
        if ($0.is(':checked')) {
            $0.closest('.Expando').find('input:checkbox').prop('checked', true);
        } else {
            $0.closest('.Expando').find('input:checkbox').prop('checked', false);
        }
    });

    $('#hobbies-interests-container .ExpandoContent input:checkbox').click(function () {
        var currentHobbySelection = $(this);
        var currentHobby = currentHobbySelection.closest('.ExpandoContent');
        var currentHobbySelections = currentHobby.find('input:checkbox');
        var currentHobbySelectionsSelected = currentHobby.find('input:checkbox:checked');

        if (currentHobbySelections.length != currentHobbySelectionsSelected.length) {
            currentHobby.closest('.Expando').find('input:checkbox:first').prop('checked', false);
        } else {
            currentHobby.closest('.Expando').find('input:checkbox:first').prop('checked', true);
        }
    });
}

